import { inject, provide } from 'vue'

import useBaseModal from '@/composables/base/modal/useBaseModal'
import useBreakpoints from '@/composables/common/useBreakpoints'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useBasePromptModal<T = any> (key: symbol) {
  const { isDesktopSize } = useBreakpoints()

  const mainModal = useBaseModal<T>(
    key,
    {
      position: isDesktopSize.value ? 'top' : 'center'
    }
  )

  return mainModal
}

export default function usePromptModal<T> (arg1?: symbol): ReturnType<typeof useBasePromptModal<T>> {
  const key = typeof arg1 === 'symbol' ? arg1 : Symbol('base-prompt-modal')
  const result = inject<ReturnType<typeof useBasePromptModal<T>> | undefined>(key, undefined)

  if (result === undefined) {
    const newResult = useBasePromptModal<T>(key)
    provide(key, newResult)
    return newResult
  }

  return result
}
